import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class VimeoVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data || []
    };
  }
  render() {
    let vimeoBlock = '';

    if (this.state.data && this.state.data.vimeo_link) {
      let linkSplit = this.state.data.vimeo_link.split('/');
      let video_id = linkSplit[linkSplit.length - 1];
      vimeoBlock = (
        <iframe
        src={"https://player.vimeo.com/video/" + video_id +
        "?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=78097"}
        width="400" height="300" frameBorder="0" title="Video Appraisal"
        webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen={true}>
        </iframe>
      );
    }
    else {
      vimeoBlock = (<p><strong>Video is still being processed. {this.state.data.video_name}</strong></p>);
    }
    return (
      <div className="col-md-6 col-sm-12">
      {vimeoBlock}
      </div>
    );
  }
}
